import apiClient from './ApiService';

const getNationalHolidays = () => apiClient.get(`/national-holidays`);

const getWorkContractTypes = () => apiClient.get(`/contract-types`);

const getQualificationTypes = () => apiClient.get(`/qualification-types`);

const getCcnls = (params) => apiClient.get(`/ccnl`, { params });

const getNationalHolidaysByMonth = async (year, month) =>
  apiClient.get(`/national-holidays?year=${year}&month=${month}`);

const getHelpDeskCategories = (payroll_id) => apiClient.get(`/payroll/${payroll_id}/help-tickets-categories`);

const getFaqs = (payroll_id) => apiClient.get(`/payroll/${payroll_id}/faqs`);

const getExternalLinks = (payroll_id) => apiClient.get(`/payroll/${payroll_id}/links`);

const GeneralService = {
  getNationalHolidays,
  getNationalHolidaysByMonth,
  getHelpDeskCategories,
  getFaqs,
  getExternalLinks,
  getWorkContractTypes,
  getQualificationTypes,
  getCcnls,
};

export default GeneralService;
